import API  from './apiConfig';

export const getInterviewForm = async (id) => {
  try {
    const response = await API.get(`/interview/${id}`);    
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const postInterviewForm = async (id, formData) => {
  try {
    const response = await API.post(`/interview/${id}`,formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInterviewQuestion = async (formData) => {
  const id = localStorage.getItem("username")
    ? JSON.parse(localStorage.getItem("username"))
    : "0000";
  try {
    const response = await API.put(`/question/${id}`,formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};